import React, { Component } from "react";
import { Row, Col, Button, Tabs } from "antd";
import { withRouter } from "react-router-dom";
import "./JoinWork.css";
import JoinWorkList from "./JoinWorkList";
import JoinWorkListExpired from "./JoinWorkListExpired";
const { TabPane } = Tabs;
class JoinWork extends Component {
  render() {
    return (
      <div style={{ paddingLeft: 15 }}>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Хамтран ажиллах санлын жагсаалт" key="1">
            <JoinWorkList />
          </TabPane>
          <TabPane tab="Хугацаа дууссан" key="2">
            <JoinWorkListExpired />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default withRouter(JoinWork);
